import { InjectionToken } from '@angular/core';
import { FormControl } from '@angular/forms';

import { BehaviorSubject } from 'rxjs';

export interface SearchFeature {
  searchControl$: BehaviorSubject<FormControl<string | null>>;
}

export const SEARCH_FEATURE = new InjectionToken<SearchFeature>('search feature');
